import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import type { ReactNode } from 'react';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/AnsimUsage/AnsimUsage.module.scss';
interface UsageTabCardProps {
  readonly tabNumber: string;
  readonly tabContent: ReactNode;
  readonly state: 'default' | 'selected' | 'visited';
  readonly onClick: () => void;
}
export default function UsageTabCard(t0) {
  const $ = _c(13);
  const {
    tabNumber: t1,
    tabContent: t2,
    state: t3,
    onClick
  } = t0;
  const tabNumber = t1 === undefined ? "01." : t1;
  const tabContent = t2 === undefined ? "\uAC00\uC785\uBB38\uC758" : t2;
  const state = t3 === undefined ? "default" : t3;
  const t4 = styles[state];
  let t5;
  if ($[0] !== t4) {
    t5 = clsx(styles.UsageTabCard, t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = state === "selected";
  const t7 = state === "default" ? "var(--color-gray-600)" : "var(--color-primary-500)";
  let t8;
  if ($[2] !== t7 || $[3] !== tabNumber) {
    t8 = <Text as="p" category="title" variant="b2" color={t7}>{tabNumber}</Text>;
    $[2] = t7;
    $[3] = tabNumber;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== tabContent) {
    t9 = <Text as="span" className={styles.tabContent} category="heading" variant="m3" color="var(--color-gray-700)">{tabContent}</Text>;
    $[5] = tabContent;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== onClick || $[8] !== t5 || $[9] !== t6 || $[10] !== t8 || $[11] !== t9) {
    t10 = <button type="button" className={t5} onClick={onClick} aria-pressed={t6}>{t8}{t9}</button>;
    $[7] = onClick;
    $[8] = t5;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
}